import Marionette from "backbone.marionette";

import NoteEditorBehavior from "../../../../behaviors/note-editor";
import TooltipBehavior from "../../../../behaviors/tooltip";

import templates from "../../../../utils/templates";

const DEFAULTS = {
  className: "panel panel-default rvc-panel rvc-panel-lg",
  template: templates.find("chart_reviews", "chart_edit_chart_notes"),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      {
        behaviorClass: NoteEditorBehavior,
        opts: {
          service: "chart-reviews:notes",
          config: {
            id: this.options.model.get("id"),
          },
        },
      },
      { behaviorClass: TooltipBehavior },
    ];
  }

  initialize() {
    this.listenTo(this.model, "change", this._onUIModelChange);
    this.listenTo(this.model.getNotes(), "update", this._onUIModelChange);
  }

  onAttach() {
    this._notifyBehaviors();
  }

  _onUIModelChange() {
    this.render();
    this._notifyBehaviors();
  }

  _notifyBehaviors() {
    this.triggerMethod("ContentRendered");
  }
}

export { View as default };
